import {
  managerProfileConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { managerProfileService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const { MANAGERS_DATA, MANAGERS_DETAIL, PAGINATED_MANAGERS_DATA } =
  managerProfileConstants;

//Fetching manager details
const getManagerDetails = (managerId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DETAIL, () =>
      managerProfileService
        .getManagerDetails(managerId)
        .then(
          (response) => {
            dispatch(success(response || [], MANAGERS_DETAIL));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Fetching paginated manager details
const getAllStoresByManagerId = (body, managerId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DATA, () =>
      managerProfileService
        .getAllStoresByManagerId(body, managerId)
        .then(
          (response) => {
            dispatch(success(response, PAGINATED_MANAGERS_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Exporting functions for other files
export const managerProfileActions = {
  getManagerDetails,
  getAllStoresByManagerId,
};
